import type { CmpHider } from './types';

export const osano: CmpHider = {
  id: 'osano',
  label: 'Osano',
  css: `
      /* Osano Cookie Consent: the whole consent UI mounts inside a
         .osano-cm-window container directly on <body>, holding the visible
         consent dialog (.osano-cm-dialog / .osano-cm-window__dialog), a
         persistent fixed floating "storage/cog" widget
         (.osano-cm-widget / .osano-cm-window__widget) that stays after consent,
         and the preferences drawer with its full-screen dimming backdrop
         (.osano-cm-info-dialog, bg rgba(0,0,0,0.45)). All three are children of
         .osano-cm-window, so hiding that container removes the dialog, the
         backdrop, and the floating widget in one go. We also list the dialog,
         backdrop (older .osano-cm-window__overlay), and widget selectors
         explicitly so a build that mounts them outside the window is still
         covered. Osano does not lock page scroll via a body class or inline
         style on the sites observed; if a build does, the
         html/html-body[style*="overflow"] release rule above (added for
         Cookiebot) already out-specifies an inline overflow lock. */
      .osano-cm-window,
      .osano-cm-dialog,
      .osano-cm-window__dialog,
      .osano-cm-info-dialog,
      .osano-cm-window__info-dialog,
      .osano-cm-window__overlay,
      .osano-cm-widget,
      .osano-cm-window__widget { display: none !important; }
  `,
};
